import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideos"><Path d="M4.5 3.5H19.5M2.5 5.5H21.5V20.5H2.5V5.5ZM10.5 10.5V15.5L14 13L10.5 10.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVideos;
